import React, { useState } from "react";
import "../styles/Contact.css";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import "aos/dist/aos.css";
import ModalAlert from "./ModalAlert";
import { FaCircleNotch } from "react-icons/fa";
import { IoPaperPlaneOutline } from "react-icons/io5";
import axios from "axios";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const messagesCollection = collection(db, "mensagens");
      await addDoc(messagesCollection, {
        ...formData,
        timestamp: Date.now(),
      });
      const emailFormData = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        emailFormData.append(key, value);
      });
      await axios.post("/send", emailFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setIsAlertOpen(true);
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Erro ao enviar o formulário: ", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleAlertClose = () => {
    setIsAlertOpen(false);
  };

  return (
    <section data-aos="fade-up" id="contact" className="contact">
      <div className="contactContainer">
        <h2 className="sectionTitle">Entre em Contato</h2>
        <p className="sectionDescription">
          Entre em contato conosco para obter mais informações ou solicitar um
          orçamento.
        </p>
        <form className="contactForm" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Seu nome"
            className="inputField"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Seu e-mail"
            className="inputField"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Sua mensagem. Ex: quero saber mais sobre seus serviços"
            className="inputField"
            value={formData.message}
            onChange={handleChange}
          />
          <button type="submit" className="submitButton">
            {isLoading ? (
              <FaCircleNotch className="icon-spin" />
            ) : (
              <span>
                Enviar <IoPaperPlaneOutline className="icon" />
              </span>
            )}
          </button>
        </form>
      </div>
      {isAlertOpen && (
        <ModalAlert
          message="Recebemos seu email! Entraremos em contato para passar mais informações em breve."
          onClose={handleAlertClose}
        />
      )}
    </section>
  );
};

export default Contact;
